import { render, staticRenderFns } from "./addImageLibraryVant.vue?vue&type=template&id=2a401254&scoped=true&"
import script from "./addImageLibraryVant.vue?vue&type=script&lang=js&"
export * from "./addImageLibraryVant.vue?vue&type=script&lang=js&"
import style0 from "./addImageLibraryVant.vue?vue&type=style&index=0&id=2a401254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a401254",
  null
  
)

export default component.exports